/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  notes: 'Notes',
  note: 'Note',
  saved: 'Sauver',
  pin: 'Épingler',
  unpin: 'Détacher',
  unpinFailure: 'La note n\'a pas pu être détachée.',
  download: 'Télécharger',
  share: 'Partager',
  shareSuccess: 'Note partagée avec succès.',
  shareFailure: 'La note n\'a pas pu être partagée.',
  delete: 'Supprimer',
  deletePrompt: 'Voulez-vous vraiment supprimer cette note ?',
  search: 'Chercher',
  syncFailure: 'Les notes n\'ont pas pu être synchronisées.',
  filter: 'Filtre',
  keyword: 'Mot-clé',
  newNote: 'Nouvelle note',
  add: 'Ajouter',
  created: 'Créé',
  modified: 'Modifié',
  selectNote: 'Sélectionnez une note',
  selectNoteInformation: 'Ce panneau affichera des informations et des actions utiles une fois que vous aurez sélectionné une note dans la liste des notes.',
  welcome: 'Bienvenu·e!',
  selectNoteOrCreate: 'Sélectionnez une note ou créez-en une nouvelle.',
  conflict: 'Conflit',
  syncingGotDisabled: 'La synchronisation des notes a été désactivée en raison d\'erreurs inattendues.',
  notFoundOrNotSynced: 'La note n\'a pas été trouvée ou n\'est pas encore synchronisée.',
}
